import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const metabase = defineConnector({
  identifier: "metabase",
  name: "Metabase",
  tagLine: "Open-source business intelligence platform",
  keywords:
    "bi business intelligence analytics dashboards questions collections",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a Metabase API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Metabase, open **Admin settings → Authentication → API keys** and create an API key with the access your integration needs.",
        },
      ],
    },
    {
      title: "Enter your Metabase details",
      items: [
        {
          kind: "baseUrl",
          label: "Metabase URL",
          required: true,
          placeholder: "https://metabase.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/permissions/group`,
  },
});
